export const INTERNATIONAL_SHIPPING_MODAL_ID = 'internationalShippingModalId';
